<div class="permit-info" *ngIf="permit">

    <!-- ===== 0. CATEGORY + PERMIT TYPE (breadcrumb, read-only) ===== -->
    <div class="category-type-card">
        <div class="permit-header-row">

            <!-- Icon + permit number badge -->
            <div class="icon-column">
                <div class="category-icon">
                    <i [ngClass]="categoryIconClass" class="subject-icon"></i>
                </div>
                <span class="permit-id-badge" *ngIf="permit.permitId">{{ permit.permitId }}</span>
                <span class="permit-external-number" *ngIf="permit.externalPermitNumber">{{ permit.externalPermitNumber }}</span>
            </div>

            <!-- Category > Permit type breadcrumb -->
            <div class="text-column">
                <div class="category-name">{{ categoryLabel(permit.category) }}</div>
                <div class="breadcrumb-row">
                    <span class="breadcrumb-arrow">└</span>
                    <span class="subject-name">{{ permitTypeLabel(permit.permitType) }}</span>
                </div>
                <div class="breadcrumb-row department-row">
                    <span class="breadcrumb-arrow">└</span>
                    <mat-select
                        class="department-select-inline"
                        panelClass="department-select-panel"
                        [value]="permit.department?._id"
                        (selectionChange)="onDepartmentChange($event.value)">
                        <mat-option *ngFor="let dept of departments" [value]="dept._id">
                            {{ departmentLabel(dept) }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>

        </div>
    </div>

    <div class="info-divider"></div>

    <!-- ===== 4. APPLICANT + LOCATION ===== -->
    <div class="applicant-location-card">
        <div class="applicant-location-grid">

            <!-- Demandeur -->
            <div class="grid-col">
                <div class="section-label-upper">{{ 'permit.manage.info.applicant' | translate }}</div>
                <div class="requester-content" *ngIf="applicantName">
                    <div class="requester-row">
                        <div class="user-avatar">
                            <img *ngIf="applicantPicture" [src]="applicantPicture" alt="">
                            <span *ngIf="!applicantPicture">{{ getInitials(applicantName) }}</span>
                        </div>
                        <a *ngIf="permit.applicant?.user" [routerLink]="['/user-update', permit.applicant.user]" target="_blank" class="user-name">
                            {{ applicantName }}
                        </a>
                        <span *ngIf="!permit.applicant?.user" class="user-name">{{ applicantName }}</span>
                        <div class="applicant-type" *ngIf="permit.applicantType">
                        {{ ('permit.manage.info.applicant_type_' + permit.applicantType) | translate }}
                    </div>
                    </div>
                    <div class="contact-rows">
                        <a *ngIf="applicantPhone" class="contact-row" href="tel:{{ applicantPhone }}">
                            <mat-icon class="contact-icon">phone</mat-icon>
                            <span>{{ applicantPhone }}</span>
                        </a>
                        <a *ngIf="applicantEmail" class="contact-row" href="mailto:{{ applicantEmail }}">
                            <mat-icon class="contact-icon">email</mat-icon>
                            <span>{{ applicantEmail }}</span>
                        </a>
                    </div>
                </div>
                <span class="no-value" *ngIf="!applicantName">{{ 'permit.manage.info.no_applicant' | translate }}</span>
            </div>

            <!-- Emplacement -->
            <div class="grid-col">
                <div class="section-label-upper">{{ 'permit.manage.info.location' | translate }}</div>
                <div class="address-content">
                    <div class="address-icon-row" *ngIf="permit.location?.address">
                        <mat-icon class="address-icon">place</mat-icon>
                        <span class="address-line">{{ permit.location.address }}</span>
                    </div>
                    <span class="no-value" *ngIf="!permit.location?.address">{{ 'permit.manage.info.no_location' | translate }}</span>
                    <button *ngIf="hasValidLocation()" type="button" class="map-toggle-btn" (click)="toggleMap()">
                        {{ isMapOpen ? ('permit.manage.info.hide_map' | translate) : ('permit.manage.info.view_map' | translate) }}
                        <mat-icon class="map-toggle-icon">{{ isMapOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </div>
            </div>

        </div>

        <!-- Map accordion -->
        <div class="map-container" *ngIf="isMapOpen">
            <div id="permit-detail-map"></div>
        </div>
    </div>

    <div class="info-divider"></div>

    <!-- ===== 5. CONTRACTOR ===== -->
    <app-permit-section-block
        *ngIf="permit.contractor"
        [title]="'permit.manage.info.contractor' | translate">
        <div class="contractor-block">
            <ng-container *ngIf="permit.contractor.selfContractor; else contractorDetails">
                <span class="contractor-self">{{ 'permit.manage.info.contractor_self' | translate }}</span>
            </ng-container>
            <ng-template #contractorDetails>
                <div class="contractor-name" *ngIf="permit.contractor.name">
                    {{ permit.contractor.name }}
                </div>
                <div class="contractor-row" *ngIf="permit.contractor.rbq">
                    <span class="contractor-label">{{ 'permit.manage.info.rbq' | translate }}: </span>
                    <span>{{ permit.contractor.rbq }}</span>
                </div>
                <div class="contact-row" *ngIf="permit.contractor.phone">
                    <mat-icon class="contact-icon">phone</mat-icon>
                    <a href="tel:{{ permit.contractor.phone }}">{{ permit.contractor.phone }}</a>
                </div>
                <div class="contact-row" *ngIf="permit.contractor.email">
                    <mat-icon class="contact-icon">email</mat-icon>
                    <a href="mailto:{{ permit.contractor.email }}">{{ permit.contractor.email }}</a>
                </div>
            </ng-template>
        </div>
    </app-permit-section-block>

    <!-- ===== 6. FEES ===== -->
    <div class="fees-card" *ngIf="permit.fees?.length">
        <div class="fees-card__title">{{ 'permit.manage.info.fees' | translate }}</div>

        <div class="fees-list">
            <div class="fee-row" *ngFor="let fee of permit.fees">
                <div class="fee-row__label">{{ fee.description }}</div>
                <div class="fee-row__amount">{{ fee.amount | currency:'CAD':'symbol-narrow':'1.2-2' }}</div>
                <div class="fee-row__status">
                    <span class="badge">{{ ('permit.manage.info.fee_timing_' + fee.timing) | translate }}</span>
                </div>
            </div>

            <div class="fee-total">
                <span>{{ 'permit.manage.info.fee_total' | translate }}</span>
                <span>{{ feesTotal | currency:'CAD':'symbol-narrow':'1.2-2' }}</span>
            </div>
        </div>

        <!-- Payment form (permit-level). Explicit save: nothing here persists until it is pressed. -->
        <form [formGroup]="feeForm" class="payment-toggle" (ngSubmit)="saveFee()">
            <div class="fee-paid-row">
                <span class="fee-paid-label">{{ 'permit.manage.info.fee_payment_received' | translate }}</span>
                <app-form-toggle formControlName="paid"></app-form-toggle>
            </div>

            <div class="payment-toggle__text">
                <div class="payment-toggle__hint">{{ 'permit.manage.info.fee_payment_received_hint' | translate }}</div>

                <div class="fee-reference-row" *ngIf="feeForm.value.paid">
                    <mat-form-field appearance="outline" class="fee-reference-field">
                        <mat-label>{{ 'permit.manage.info.fee_payment_reference' | translate }}</mat-label>
                        <input matInput formControlName="paymentReference">
                    </mat-form-field>
                </div>

                <div class="fee-paid-at" *ngIf="permit.fees[0]?.paidAt">
                    <span class="fee-paid-at-label">{{ 'permit.manage.info.fee_paid_at' | translate }}: </span>
                    <span>{{ formatDate(permit.fees[0].paidAt) }}</span>
                </div>

                <div class="fee-save-row" *ngIf="feeDirty">
                    <button mat-raised-button color="primary" type="submit" [disabled]="savingFee">
                        {{ 'permit.manage.info.fee_save' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>

    <!-- ===== 7. FORM DATA ===== -->
    <app-permit-section-block
        *ngIf="permit.formData && formDataEntries.length"
        [title]="'permit.manage.info.form_data' | translate">
        <dl class="form-data-list">
            <ng-container *ngFor="let entry of formDataEntries; trackBy: trackFormDataEntry">
                <dt class="form-data-key">{{ entry.label }}</dt>
                <dd class="form-data-value">
                    <ng-container *ngIf="isFormDataFileUrlArray(entry.value); else singleFormDataValue">
                        <div class="form-data-file-list">
                            <a *ngFor="let url of entry.value" [href]="url" target="_blank" rel="noopener noreferrer" class="form-data-file-link">
                                {{ formDataFileName(url) }}
                            </a>
                        </div>
                    </ng-container>
                    <ng-template #singleFormDataValue>
                        <a *ngIf="isFormDataFileUrl(entry.value)" [href]="entry.value" target="_blank" rel="noopener noreferrer" class="form-data-file-link">
                            {{ formDataFileName(entry.value) }}
                        </a>
                        <ng-container *ngIf="!isFormDataFileUrl(entry.value)">{{ entry.value }}</ng-container>
                    </ng-template>
                </dd>
            </ng-container>
        </dl>
    </app-permit-section-block>

    <div class="info-divider"></div>

    <!-- ===== 8. VALIDITY ===== -->
    <app-permit-section-block
        *ngIf="permit.validityStartDate || permit.validityEndDate"
        [title]="'permit.manage.info.validity' | translate">
        <div class="validity-block">
            <div class="validity-header">
                <ng-container *ngIf="permit.syncStatus">
                    <span
                        class="sync-dot"
                        [style.background-color]="getSyncColor(permit.syncStatus)"
                        [matTooltip]="getSyncTooltip(permit.syncStatus) | translate"
                        matTooltipPosition="above">
                    </span>
                </ng-container>
            </div>
            <div class="validity-dates">
                <div class="validity-row" *ngIf="permit.validityStartDate">
                    <span class="validity-label">{{ 'permit.manage.info.validity_start' | translate }}: </span>
                    <span>{{ formatDate(permit.validityStartDate) }}</span>
                </div>
                <div class="validity-row" *ngIf="permit.validityEndDate">
                    <span class="validity-label">{{ 'permit.manage.info.validity_end' | translate }}: </span>
                    <span>{{ formatDate(permit.validityEndDate) }}</span>
                </div>
            </div>
        </div>
    </app-permit-section-block>

    <!-- ===== 10. FILES ===== -->
    <div class="files-card">
        <div class="files-header">
            <span class="section-label-upper">{{ 'permit.manage.info.files' | translate }}</span>
        </div>
        <div class="files-grid">

            <div class="file-container" *ngFor="let file of permit.files; let i = index">
                <div class="delete-file-btn" (click)="deleteFile(i); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                </div>
                <ng-container *ngIf="isImage(file)">
                    <div class="file-preview" (click)="openFile(file)">
                        <img [src]="file.url" [alt]="fileName(file)">
                    </div>
                </ng-container>
                <ng-container *ngIf="!isImage(file)">
                    <div class="file-preview document-icon" (click)="openFile(file)">
                        <img *ngIf="isDocumentPdf(file)" src="assets/images/pdf-file.svg" alt="PDF File">
                        <img *ngIf="isDocumentWord(file)" src="assets/images/word-file.svg" alt="Word File">
                        <img *ngIf="isDocumentExcel(file)" src="assets/images/sheets-file.svg" alt="Excel File">
                        <mat-icon *ngIf="!isDocumentPdf(file) && !isDocumentWord(file) && !isDocumentExcel(file)">insert_drive_file</mat-icon>
                    </div>
                </ng-container>
                <div class="file-name" [title]="fileName(file)">{{ fileName(file) }}</div>
            </div>

            <div class="file-container add-file-container">
                <button type="button" #addFileBtn class="add-file-btn" [class.disabled]="uploading" [disabled]="uploading" (click)="onAddFileClick()">
                    <mat-icon>add</mat-icon>
                </button>
                <input
                    #fileInput
                    type="file"
                    class="hidden-file-input"
                    (change)="onFileSelected($event)"
                    [disabled]="uploading">

                <!-- position: fixed + a computed screen position, so it isn't clipped by the scrollable tab pane's overflow. -->
                <div class="field-picker" *ngIf="showFieldPicker" [style.top.px]="pickerPosition.top" [style.left.px]="pickerPosition.left">
                    <button
                        type="button"
                        class="field-picker-option"
                        *ngFor="let field of documentFieldOptions"
                        [disabled]="isFileFieldFull(field)"
                        (click)="chooseDocumentField(field.fieldId, field)"
                    >
                        {{ documentFieldLabel(field) }}
                    </button>
                    <button type="button" class="field-picker-option other" (click)="chooseDocumentField(otherDocumentField)">
                        {{ 'permit.manage.info.document_other' | translate }}
                    </button>
                </div>
            </div>

        </div>
    </div>

</div>
